export const sharingUnitTariffUpdatedFilter = {
  key: 'updated-filter',
  query: 'updated',
  isAvailable: ({ isManufacturer }: { isManufacturer: boolean }) =>
    !isManufacturer,
};
